import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to creat a stronger CTA for FD new retailer offer banner. This XP is limited to the logged in user experience.
 * https://www.notion.so/faire/Creating-a-stronger-CTA-for-FD-new-retailer-offer-banner-1f22efb5c25a80d49dbeee51582cb6a3
 */
export const FAIRE_DIRECT_SITEWIDE_BANNER_250602 =
  'FAIRE_DIRECT_SITEWIDE_BANNER_250602' as SettingConst<
    'FAIRE_DIRECT_SITEWIDE_BANNER_250602',
    boolean,
    'RETAILER'
  >;
